import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "filterButton"];
  static values = {
    count: Number
  };

  connect() {
    // Set the first button as active on load
    if (this.hasFilterButtonTarget) {
      this.setActiveButton(0);
    }

    // Add scroll event listener to update active button
    if (this.hasContainerTarget) {
      this.containerTarget.addEventListener("scroll", this.handleScroll.bind(this));
    }
  }

  disconnect() {
    if (this.hasContainerTarget) {
      this.containerTarget.removeEventListener("scroll", this.handleScroll.bind(this));
    }
  }

  scrollToSlide(event) {
    const button = event.currentTarget;
    const slideIndex = parseInt(button.dataset.slideIndex);

    if (!this.hasContainerTarget) return;

    const container = this.containerTarget;
    const slides = container.querySelectorAll(".scroll-snap-start");

    if (slides[slideIndex]) {
      // Scroll to the specific slide
      slides[slideIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start"
      });

      // Update active button
      this.setActiveButton(slideIndex);
    }
  }

  handleScroll() {
    // Debounce scroll events
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }

    this.scrollTimeout = setTimeout(() => {
      this.updateActiveButton();
    }, 100);
  }

  updateActiveButton() {
    if (!this.hasContainerTarget || !this.hasFilterButtonTarget) return;

    const container = this.containerTarget;
    const slides = container.querySelectorAll(".scroll-snap-start");
    const containerRect = container.getBoundingClientRect();

    // Find the slide that is most visible
    let mostVisibleIndex = 0;
    let maxVisibleArea = 0;

    slides.forEach((slide, index) => {
      const slideRect = slide.getBoundingClientRect();
      const visibleWidth = Math.min(slideRect.right, containerRect.right) -
                          Math.max(slideRect.left, containerRect.left);

      if (visibleWidth > maxVisibleArea) {
        maxVisibleArea = visibleWidth;
        mostVisibleIndex = index;
      }
    });

    this.setActiveButton(mostVisibleIndex);
  }

  setActiveButton(index) {
    if (!this.hasFilterButtonTarget) return;

    this.filterButtonTargets.forEach((button, buttonIndex) => {
      const slideIndex = parseInt(button.dataset.slideIndex);

      if (slideIndex === index) {
        // Active state
        button.classList.remove("bg-white", "text-nr-text");
        button.classList.add("bg-nr-green", "text-white");
      } else {
        // Inactive state
        button.classList.remove("bg-nr-green", "text-white");
        button.classList.add("bg-white", "text-nr-text");
      }
    });
  }
}
